export type HighlightSegment = { text: string; isMatch: boolean };

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Splits text into segments, marking every case-insensitive occurrence of each query word.
const highlightWords = (text: string, query: string): HighlightSegment[] => {
  const words = [...new Set(query.split(/\s+/).filter(Boolean))];
  if (!text || words.length === 0) return [{ text, isMatch: false }];

  // Longest first so "pine" doesn't pre-empt "pineapple" when both are typed.
  const pattern = words
    .sort((a, b) => b.length - a.length)
    .map(escapeRegExp)
    .join('|');
  const isWord = new RegExp(`^(?:${pattern})$`, 'i');

  return text
    .split(new RegExp(`(${pattern})`, 'i'))
    .filter(Boolean)
    .map((segment) => ({ text: segment, isMatch: isWord.test(segment) }));
};

export default highlightWords;
